/* Weight is overridable because the same glyph is drawn at two scales: the
   connection-row refresh at 14px/2, and the MCP Analytics page control at 18px/2.2
   (agent-studio.html:5872). Colour always comes from the parent via
   `currentColor` — never baked into the SVG. */
export function RefreshIcon({
  size = 14,
  strokeWidth = 2,
}: { size?: number; strokeWidth?: number } = {}) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} stroke="currentColor" fill="none" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="23 4 23 10 17 10"/>
      <polyline points="1 20 1 14 7 14"/>
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
    </svg>
  )
}
